export enum AQIStatus {
  GOOD = "Good",
  MODERATE = "Moderate",
  UNHEALTHY_FOR_SENSITIVE_GROUPS = "Unhealthy for Sensitive Groups",
  UNHEALTHY = "Unhealthy",
  VERY_UNHEALTHY = "Very Unhealthy",
  HAZARDOUS = "Hazardous",
}

export enum AQIStatusColor {
  GOOD = "#00e400",
  MODERATE = "#ffff00",
  UNHEALTHY_FOR_SENSITIVE_GROUPS = "#ff7e00",
  UNHEALTHY = "#ff0000",
  VERY_UNHEALTHY = "#8f3f97",
  HAZARDOUS = "#7e0023",
}
